/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_G5_TInputs */

const en_mk_sec_pg_g5_t = /** @type {(inputs: Mk_Sec_Pg_G5_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attempt and time limits`)
};

const id_mk_sec_pg_g5_t = /** @type {(inputs: Mk_Sec_Pg_G5_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batas percobaan dan waktu`)
};

/**
* | output |
* | --- |
* | "Attempt and time limits" |
*
* @param {Mk_Sec_Pg_G5_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_g5_t = /** @type {((inputs?: Mk_Sec_Pg_G5_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_G5_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_g5_t(inputs)
	return en_mk_sec_pg_g5_t(inputs)
});